module.exports = __webpack_public_path__ + "c5179fae01bd9dbfe01aa295b7bf8a24.svg";